
<template>
    <FormulateForm
        class="form form--forgotPassword"
        @submit="submitRequest"
        v-model="formFields"
    >
        <SVGlogo class="logo logo--lg hide--mob" />

        <transition name="fade-in" mode="out-in">
            <Alert type="error" v-if="error">
                {{ error }}
            </Alert>
        </transition>

        <transition name="fade-in" mode="out-in">
            <Alert type="success" v-if="success" :hideTitle="true">
                {{ success }}
            </Alert>
        </transition>

        <FormulateInput
            class="form__group"
            label="Email"
            type="email"
            name="email"
            validation="email"
        >
            <template #label="{ label, id }">
                <label :for="id">
                    {{ label }}<span class="form--required" aria-label="required">*</span>
                </label>
            </template>
        </FormulateInput>

        <footer class="form__actions center">
            <FormulateInput
                :class="[
                    'btn--full',
                    { 'btn--success' : btnSuccess },
                    { 'btn--loading' : loading }
                ]"
                :disabled="loading"
                type="submit"
                name="submit"
            >
                {{ btnLabel }} <Spinner v-if="loading" />
            </FormulateInput>

            <a href="#" @click.prevent="$emit('toggleForgotPassword')">Back to Log In</a>
        </footer>

    </FormulateForm>
</template>

<script>
export default {
    data() {
        return {
            formFields: {},
            error: null,
            loading: false,
            btnSuccess: false,
            success: null,
        }
    },

    computed: {
        btnLabel () {
            if (this.loading) return 'Submitting Email...'
            if (this.btnSuccess) return 'Success'
            return 'Request New Password'
        }
    },

    methods: {
        submitRequest () {
            const { email } = this.formFields

            this.loading = true
            this.error = null

            this.axios.post('/forgot-password', { user: { email } })
                .then(({ data }) => {
                    if (data.error || data.status && data.status !== 'success') throw new Error(data.message || data.error)
                    this.success = data
                    this.btnSuccess = true

                    setTimeout(() => {
                        this.btnSuccess = false
                    }, 1500);
                })
                .catch(error => {
                    if (error.response) this.error = error.response.data
                    else if (error.request) this.error = error.request
                    else this.error = error.message
                })
                .finally(() => { this.loading = false })
        }
    },
}
</script>

